const envConfig = {
  VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL
};

const requireEnv = key => {
  const value = envConfig[key];

  if (!value) {
    throw new Error(`[http/config] Missing required environment variable: ${key}`);
  }

  return value;
};

const normalizeBaseUrl = baseUrl => {
  return baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
};

const config = Object.freeze({
  baseUrl: normalizeBaseUrl(requireEnv("VUE_APP_API_BASE_URL"))
});

export default config;
